export var reduxKey = '@@firstTimeFlags';
export var localStorageKey = '@@firstTimeFlags';
export var FirstTimeFlag;
(function (FirstTimeFlag) {
    FirstTimeFlag["ProfileHeroAidNotClosed"] = "isProfileHeroAidNotClosed";
    FirstTimeFlag["ProfileEditAidNotClosed"] = "isProfileEditAidNotClosed";
    FirstTimeFlag["WelcomePopupNotClosed"] = "isWelcomePopupNotClosed";
    FirstTimeFlag["ArtBackgroundNotUsed"] = "isArtBackgroundNotUsed";
    FirstTimeFlag["IsJournalCoverNotUsed"] = "isJournalCoverNotUsed";
    FirstTimeFlag["IsPortfolioPopupNotClosed"] = "isPortfolioPopupNotClosed";
    FirstTimeFlag["IsChatGeneralTabNotUsed"] = "isChatGeneralTabNotUsed";
    FirstTimeFlag["IsNetworkbarGroupWatchNotUsed"] = "isNetworkbarGroupWatchNotUsed";
    FirstTimeFlag["IsDollarInputMessageNotShown"] = "isDollarInputMessageNotShown";
    FirstTimeFlag["IsMcGroupSwitcherNotUsed"] = "isMcGroupSwitcherNotUsed";
    FirstTimeFlag["IsDevpageAddToGroupNotShown"] = "isDevpageAddToGroupNotShown";
    FirstTimeFlag["IsArtShopBuyButtonMessageNotShown"] = "isArtShopBuyButtonMessageNotShown";
    FirstTimeFlag["IsArtShopInSiteHeaderNotSeen"] = "isArtShopInSiteHeaderNotSeen";
    FirstTimeFlag["IsDywUnreadTooltipNotSeen"] = "isDywUnreadTooltipNotSeen";
    FirstTimeFlag["IsNewDywNotSeen"] = "isNewDywNotSeen";
    FirstTimeFlag["IsNewNCHeaderNotAcknowledged"] = "isNewNcHeaderNotAcknowledged";
    FirstTimeFlag["IsNewNCPageNotAcknowledged"] = "isNewNcPageNotAcknowledged";
})(FirstTimeFlag || (FirstTimeFlag = {}));
//# sourceMappingURL=constants.js.map